/**
 * Upozornění na stáří matky: od kolika let (podle roku líhnutí) se na kartě
 * včelstva v dlaždici Matka ukáže varování. 0 = vypnuto.
 */
import { getSetting, setSetting } from '../db/db';
import { useQuery } from './hooks';
import { plural } from './labels';
import { Chips, Section, toast } from './ui';
import { confirmSmall } from './confirm';

export const QUEEN_AGE_SETTING = 'queenAgeWarnYears';
export const DEFAULT_QUEEN_AGE = 2;

export function useQueenAgeLimit(): number | undefined {
  return useQuery(async () => (await getSetting<number>(QUEEN_AGE_SETTING)) ?? DEFAULT_QUEEN_AGE, []);
}

/** Stáří matky v letech podle roku líhnutí. */
export function queenAge(year: number, today = new Date()): number {
  return today.getFullYear() - year;
}

export const ageText = (n: number) => (n === 0 ? 'letošní' : plural(n, 'rok', 'roky', 'let'));

export function QueenAgeSetting() {
  const limit = useQueenAgeLimit();
  if (limit == null) return null;
  return (
    <Section title="Stáří matky">
      <p className="muted">Od jakého stáří (podle roku líhnutí) se na kartě včelstva v dlaždici Matka objeví upozornění.</p>
      <Chips
        ariaLabel="Upozornit od stáří"
        options={[
          [0, 'Vypnuto'],
          [1, '1 rok'],
          [2, '2 roky'],
          [3, '3 roky'],
          [4, '4 roky'],
          [5, '5 let'],
        ]}
        value={limit}
        onChange={async (v) => {
          if (v == null) return;
          await setSetting(QUEEN_AGE_SETTING, v);
          confirmSmall();
        }}
      />
      <p className="small muted">
        {limit === 0
          ? 'Upozornění je vypnuté.'
          : `Upozornění se ukáže u matek vylíhnutých v roce ${new Date().getFullYear() - limit} a dříve.`}
      </p>
    </Section>
  );
}
